/* What differs between Authorized Signatory and Key Personnel. */
export const SIGNATORY_SPEC = {
  key: "signatory",
  title: "Authorized Signatory",
  addPrompt: "Add New Authorized Signatory",
  addLabel: "Add",
  dialogAdd: "Add Authorized Signatory",
  dialogEdit: "Edit Authorized Signatory",
  /* The design labels the signatory's action "Submit" and the personnel's
     "Save"; the live forms say the same. */
  cta: "Submit",
  withNationality: true,

  companyListKey: "authorizedSignDetails",
  joinKey: "Authorized_signID",
  idKey: "authorized_signID",
  draftIdKey: "authorized_sign_draftID",
  draftLinkKey: "authorized_signID_id",

  requestType: "Authorized Signatory update request",
  followCreated: "New Authorized Signatory Added",
  followUpdated: "Authorized Signatory Updated",
  deleteMessage: "Authorized Signatory Deleted Successfully",

  /* Transcribed: a new signatory is created and then LINKED to the company in
     a second call. Key Personnel needs no link — its create carries
     current_companyID. */
  needsLink: true,
  /* Documents for this section share the company's authorised-letter path. */
  uploadPath: "authLetters",
  /* `supporting_document` and not a per-section string: the upload endpoint validates `category` against a CLOSED set (company/utils/s3_paths.py... */
  category: "supporting_document",
};

export const PERSONNEL_SPEC = {
  key: "personnel",
  title: "Key Personnel",
  addPrompt: "Add Key Personnel",
  addLabel: "Add",
  dialogAdd: "Add Key Personnel",
  dialogEdit: "Edit Key Personnel",
  cta: "Save",
  withNationality: false,

  companyListKey: "companyKeyPersonnel",
  joinKey: "key_personnelID",
  idKey: "key_personnelID",
  draftIdKey: "key_personnel_draftID",
  draftLinkKey: "key_personnelID_id",

  requestType: "Key personal update request",
  followCreated: "New Key Personnel Added",
  followUpdated: "Key Personnel Updated",
  deleteMessage: "Key Personnel Deleted Successfully",

  needsLink: false,
  uploadPath: "authLetters",
  /* `supporting_document` and not a per-section string: the upload endpoint validates `category` against a CLOSED set (company/utils/s3_paths.py... */
  category: "supporting_document",
};

export const PEOPLE_SPECS = {
  signatory: SIGNATORY_SPEC,
  personnel: PERSONNEL_SPEC,
};
